
import { nothing } from 'lit';
import { directive, Directive } from 'lit/directive.js';
import { Router } from './router.js';

export type AppLink = string|Function|undefined;

class LinkifyDirective extends Directive {
  render(_value: AppLink) {
    return nothing;
  }

  update(part: any, [value]: [AppLink]) {
    const el = part.element as HTMLElement;

    // Clean up previous state
    el.removeAttribute('href');
    el.onclick = null;
    el.style.removeProperty('cursor');

    if (typeof value === 'string') {
      el.setAttribute('href', value);
    } else if (value instanceof Function) {
      el.onclick = () => value();
      el.style.setProperty('cursor', 'pointer');
    }
  }
}

export const hrefOrClick = directive(LinkifyDirective);
// `replace` changes the current history entry instead of adding one.
export function handleLink(router: Router|undefined, link: AppLink, options?: { replace?: boolean }) {
  if (typeof link === 'string')
    router?.navigate(link, options);
  else if (link instanceof Function)
    link();
}
export type Linkifier<OPTIONS> = (options: OPTIONS, revealId?: string) => AppLink;
